

























































































































































































import SimpleFormA from '@/components/forms/SimpleFormA'
import SimpleFormB from '@/components/forms/SimpleFormB'
import SimpleFormC from '@/components/forms/SimpleFormC'
import SimpleFormD from '@/components/forms/SimpleFormD'
import SimpleFormE from '@/components/forms/SimpleFormE'
import SimpleFormF from '@/components/forms/SimpleFormF'
import SimpleFormG from '@/components/forms/SimpleFormG'
import NextButton from '@/components/shared/NextButton'
import PreviousButton from '@/components/shared/PreviousButton'
import CancelButton from '@/components/shared/CancelButton'
import {
  Box,
  ConveyorConfigurationEnum,
  ISnackbar,
  IStep,
  LayerPattern,
  MachineSettings,
  Pallet,
  PalletPattern,
  ProgramSettings,
  RobotTypeEnum,
  Settings
} from '@/model/index'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { createPatternObject } from '@/libs/palletPattern'
import Units from '@/api/utils/units'

@Component({
  components: {
    SimpleFormA: SimpleFormA,
    SimpleFormB: SimpleFormB,
    SimpleFormC: SimpleFormC,
    SimpleFormD: SimpleFormD,
    SimpleFormE: SimpleFormE,
    SimpleFormF: SimpleFormF,
    SimpleFormG: SimpleFormG,
    NextButton: NextButton,
    PreviousButton: PreviousButton,
    CancelButton: CancelButton
  },
  computed: {
    ...mapGetters('palletpatterns', [
      'selectedEntity',
      'palletPatterns',
      'currentStep',
      'error',
      'isNew'
    ]),
    ...mapGetters('settings', [ 'settings' ]),
    ...mapGetters('machinesettings', [
        'machinesettings',
        'fixedMachineSettings'
    ])
  }
})
export default class TestStepper extends Vue {
  @Prop() private selectedPalletPattern!: PalletPattern
  @Prop() private steps!: IStep[]

  private selectedEntity!: PalletPattern
  private currentStep!: number
  private valid: boolean = false
  private error!: boolean
  private isNew!: boolean
  private palletPattern!: PalletPattern
  private settings!: Settings
  private machinesettings!: MachineSettings
  private bus: Vue = new Vue()
  private snackbar: ISnackbar = {
    show: false,
    color: 'error',
    text: 'Oh oh! Something went wrong when trying to save.',
    timeout: 10000
  }
  private nextToolTip = ''
  private fixedMachineSettings!: boolean

  @Watch('selectedEntity', { deep: true })
  private selectedEntityWatcher (value: any, oldvalue: any) {
    this.populatePalletPattern(value)
  }

  private created () {
    if (this.isNew) {
      this.palletPattern = createPatternObject()
      // set default values
      this.palletPattern.programSettings = this.getProgramSettings(this.machinesettings, this.fixedMachineSettings)
      this.$store.dispatch('palletpatterns/invalidateAll')
      this.restoreCached()
    } else {
      this.populatePalletPattern(this.selectedPalletPattern)
    }
    this.$store.dispatch('palletpatterns/setStep', 1)
  }

  get units () {
    return new Units(this.settings.units || Settings.UnitsEnum.METRIC)
  }

  get propId () {
    // noinspection TypeScriptUnresolvedVariable
    return this.$route.params.id
  }

  get step () {
    return this.currentStep
  }

  set step (value: number) {
    this.$store.dispatch('palletpatterns/setStep', value)
  }

  get showError () {
    return this.error
  }
  set showError (value) {
    console.log('[ERROR] from axios in test-stepper', value)
    if (!value) {
      this.$store.dispatch('palletpatterns/closeError')
    }
  }

  @Watch('error')
  private errorWatcher (value: boolean) {
    if (value) {
      this.snackBarHandler(true, 'error', '')
      this.valid = false
    }
  }

  private validateStep (value: boolean) {
    this.valid = value
  }

  private setToolTipText (text: string) {
    this.nextToolTip = text
  }

  /**
   * NAVIGATION FUNCTIONS
   */
  private stepperNext () {
    this.bus.$emit('stepper_next')
  }

  private stepperPrevious () {
    this.bus.$emit('stepper_previous')
  }

  private next () {
    this.valid = false
    if (this.step >= this.steps.length) {
      return
    } else {
      this.$emit('submit', this.palletPattern, this.step)
    }
  }

  private previous () {
    if (this.step === 1) {
      return
    }
    this.step--
  }

  private cancel () {
    this.$emit('cancel')
  }

  private closeSnackbar () {
    this.$store.dispatch('palletpatterns/closeError')
  }

  private nextHandlerA (name: string, robotType: RobotTypeEnum) {
    this.palletPattern.name = name
    this.palletPattern.machineSettings = {...this.machinesettings}
    const previousRobotType = this.palletPattern.programSettings!.robotType
    this.palletPattern.programSettings!.robotType = robotType
    if (robotType === RobotTypeEnum.CUSTOM_SOLUTION) {
      if (previousRobotType !== robotType) {
        this.palletPattern.programSettings!.approachAngle = 45
        this.palletPattern.programSettings!.approachDistance = 200
      } else {
        const angle = this.palletPattern.programSettings!.approachAngle
        this.palletPattern.programSettings!.approachAngle = angle === 0 || angle ? Number(angle) : 45
        const distance = this.palletPattern.programSettings!.approachDistance
        this.palletPattern.programSettings!.approachDistance = distance === 0 || distance ? Number(distance) : 200
      }
    } else {
      if (previousRobotType !== robotType) {
        this.palletPattern.programSettings!.approachAngle = 45
      }
      delete this.palletPattern.programSettings!.approachDistance
    }
    this.palletPattern.programSettings!.additionalPedestalHeight = this.machinesettings.additionalPedestalHeight || 0
    if (this.palletPattern.programSettings!.conveyorConfiguration == null ||
        this.palletPattern.programSettings!.conveyorConfiguration.length === 0) {
      this.palletPattern.programSettings!.conveyorConfiguration =
          ConveyorConfigurationEnum.CENTER_RIGHT // default
    }
    this.next()
  }

  private nextHandlerB (box: Box) {
    this.palletPattern.box = box
    localStorage.setItem('cachedBox', JSON.stringify(box))
    this.next()
  }

  private nextHandlerC (settings: ProgramSettings) {
    if (settings.robotType !== RobotTypeEnum.CUSTOM_SOLUTION) {
      delete settings.approachDistance
    }
    this.palletPattern.programSettings = settings
    localStorage.setItem('cachedProgramSettings', JSON.stringify(settings))
    this.next()
  }

  private nextHandlerD (pallet: Pallet) {
    this.palletPattern.pallet = pallet
    const cache = {
      palletType: pallet.palletType,
      length: pallet.length,
      width: pallet.width,
      height: pallet.height,
      overhangB: pallet.overhangB,
      overhangT: pallet.overhangT,
      overhangR: pallet.overhangR,
      overhangL: pallet.overhangL,
      layers: pallet.layers
    }
    localStorage.setItem('cachedPallet', JSON.stringify(cache))
    this.next()
  }

  private previousHandlerE (layerPatterns: LayerPattern[]) {
    // allow the user to clear all layer patterns to enable changing box dimensions etc
    if (!this.hasAnyBoxPositions(layerPatterns)) {
      this.palletPattern.pallet!.layerPatterns = layerPatterns
    }
    this.previous()
  }

  private nextHandlerE (layerPatterns: LayerPattern[], pallet: Pallet) {
    this.palletPattern.pallet!.layerPatterns = layerPatterns
    this.palletPattern.pallet!.displayRotation = pallet.displayRotation
    this.next()
  }

  private async nextHandlerF (pallet: Partial<Pallet>) {
    if (pallet.interlayerThickness != null) {
      this.palletPattern.pallet!.interlayerThickness = pallet.interlayerThickness
    }
    this.palletPattern.pallet!.interlayerSheetPositions = pallet.interlayerSheetPositions
    this.palletPattern.pallet!.layers = pallet.layers
    this.next()
  }

  private previousHandlerG (palletPattern: PalletPattern) {
    this.palletPattern.validationStatus = palletPattern.validationStatus
    this.palletPattern.validationDetails = palletPattern.validationDetails
    this.previous()
  }

  private async finish () {
    const guid = this.selectedEntity.guid
    /*
     * DEPRECATED
     * make script/robot program on demand, depends on robot type
     *
    await post('/script/' + guid)
      .then((resp: any) => {
        console.log(`[INFO] script saved ${guid}`)
        this.snackBarHandler(true, 'success', 'Script was saved to a file')
        setTimeout(() => {
          this.$emit('finish')
        }, 2000)
      })
      .catch((e: any) => {
        console.log(`[ERROR] script saving ${guid}, `, e)
        this.snackBarHandler(true, 'error', 'Script was not saved')
      })
     */
    this.$emit('finish')
  }

  /**
   * UTILITY
   */
  private populatePalletPattern (palletPattern: PalletPattern) {
    // console.log('[DEBUG] populating palletpattern')
    this.palletPattern = Object.assign({}, palletPattern)
  }

  private getStepTitle () {
    const title = this.steps[this.step - 1] ? this.$t(this.steps[this.step - 1].title) : ''
    return title
  }

  private getPatternName () {
    return this.palletPattern.name! ? `${this.$t('menu.pattern')}: ${this.palletPattern.name}` : ''
  }

  private patternHasBoxPositions (): boolean {
    // return true if the current pallet pattern has any layer pattern with box positions
    if (this.palletPattern && this.palletPattern.pallet) {
      return this.hasAnyBoxPositions(this.palletPattern.pallet.layerPatterns!)
    }
    return false
  }

  private hasAnyBoxPositions (layerPatterns: LayerPattern[]): boolean {
    if (layerPatterns) {
      return layerPatterns.some(layerPattern =>
          (layerPattern && layerPattern.boxPositions && layerPattern.boxPositions.length > 0) ? true : false
      )
    }
    return false
  }

  private restoreCached () {
    const box = localStorage.getItem('cachedBox')
    if (box) {
      this.palletPattern.box = JSON.parse(box) as Box
    }
    const programSettings = localStorage.getItem('cachedProgramSettings')
    if (programSettings) {
      const cachedProgramSettings = JSON.parse(programSettings) as ProgramSettings
      if (this.fixedMachineSettings) {
        this.palletPattern.programSettings!.boxOrientationOnConveyor = cachedProgramSettings.boxOrientationOnConveyor
        this.palletPattern.programSettings!.labelPosition = cachedProgramSettings.labelPosition
      } else {
        this.palletPattern.programSettings = cachedProgramSettings
      }
    }
    const pallet = localStorage.getItem('cachedPallet')
    if (pallet) {
      const cached = JSON.parse(pallet) as Pallet
      if (!this.palletPattern.pallet) {
        this.palletPattern.pallet = {}
      }
      this.palletPattern.pallet.palletType = cached.palletType
      this.palletPattern.pallet.length = cached.length
      this.palletPattern.pallet.width = cached.width
      this.palletPattern.pallet.height = cached.height
      this.palletPattern.pallet.overhangB = cached.overhangB
      this.palletPattern.pallet.overhangT = cached.overhangT
      this.palletPattern.pallet.overhangR = cached.overhangR
      this.palletPattern.pallet.overhangL = cached.overhangL
      // this.palletPattern.pallet!.layers = cached.layers
    }
  }

  private snackBarHandler (state: boolean, color: string, text: string) {
    this.snackbar.show = state
    this.snackbar.color = color
    if (text && text !== '') {
      this.snackbar.text = text
    }
  }

  private getProgramSettings(machineSettings: MachineSettings, fixedMachineSettings: boolean) {
    if (fixedMachineSettings) {
      const isCustomSolution = machineSettings.robotType === RobotTypeEnum.CUSTOM_SOLUTION
      const angle = machineSettings.approachAngle
      return {
        robotType: machineSettings.robotType,
        approachAngle: isCustomSolution ? 45 : (angle === 0 || angle ? Number(angle) : 45),
        ...(isCustomSolution ? { approachDistance: 200 } : {}),
        conveyorConfiguration: machineSettings.conveyorConfiguration
            || ((machineSettings.robotType!.startsWith('RI20')) ? ConveyorConfigurationEnum.CENTER_LEFT : ConveyorConfigurationEnum.LEFT),
        additionalPedestalHeight: machineSettings.additionalPedestalHeight || 0,
        boxOrientationOnConveyor: ProgramSettings.BoxOrientationOnConveyorEnum.SHORT_SIDE_LEADING,
        labelPosition: ProgramSettings.LabelPositionEnum.FRONT
      }
    } else {
      return {
        boxOrientationOnConveyor: ProgramSettings.BoxOrientationOnConveyorEnum.SHORT_SIDE_LEADING,
        conveyorConfiguration: ConveyorConfigurationEnum.CENTER_RIGHT,
        labelPosition: ProgramSettings.LabelPositionEnum.FRONT
      }
    }
  }

  private isCustomSolution() {
    return RobotTypeEnum.CUSTOM_SOLUTION === this.palletPattern!.programSettings!.robotType
  }

}
